import React, { useEffect, useState, ReactNode } from 'react';
import * as signalR from '@microsoft/signalr';
import { getSettings } from '../Helpers/SettingsHelper';
import { SignalRContext } from './SignalRContext';

export const SignalRProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [ProgressConnection, setProgressConnection] = useState<signalR.HubConnection | null>(null);

    useEffect(() => {
        const createConnection = async () => {
            const settings = getSettings();
            const connection = new signalR.HubConnectionBuilder()
                .withUrl(settings.settings.apiUrl + 'ProgressHub')
                .withAutomaticReconnect()
                .build();

            try {
                await connection.start();
                console.log('SignalR Connected.');
            } catch (error) {
                console.error('SignalR Connection Error: ', error);
            }

            setProgressConnection(connection);

            // Cleanup on unmount
            return () => {
                if (connection) {
                    connection.stop();
                }
            };
        };

        createConnection();
    }, []);

    return (
        <SignalRContext.Provider value={{ ProgressConnection }}>
            {children}
        </SignalRContext.Provider>
    );
};
